import { Chip, Tooltip } from "@mui/material";
import { absenceTypeToString } from "utilities/formatAbsence";
import { absenceTypeToColor } from "utilities/formatAbsence";
import { TimeEntry } from "models/TimeEntry";
import { Chat } from "@mui/icons-material";

type AbsenceTypeChipProps = { entry: TimeEntry };

const AbsenceTypeChip: React.FC<AbsenceTypeChipProps> = (props) => {
  const { entry } = props;

  return (
    <Tooltip arrow title={entry.message}>
      <Chip
        size="small"
        variant="outlined"
        label={absenceTypeToString(entry.type)}
        icon={!!entry.message ? <Chat /> : undefined}
        sx={{
          flexDirection: "row-reverse",
          gap: 0.5,
          borderColor: `${absenceTypeToColor(entry.type)}.main`,
          bgcolor: `background.${absenceTypeToColor(entry.type)}`,
          "& .MuiSvgIcon-root": {
            marginLeft: "-4px",
            marginRight: "6px",
          },
        }}
      />
    </Tooltip>
  );
};

export default AbsenceTypeChip;
